import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import axios from 'axios';
import isIos from "is-ios";
import { Badge, Row, Col, TabContent, TabPane, Nav, NavItem, NavLink, Card, CardImg, CardTitle } from 'reactstrap';
import classnames from 'classnames';

import StarRatingComponent from 'react-star-rating-component';

import { showMessage } from '../../actions/FlashMessageActions';

import * as vars from '../../constants/variables';

import { show, hide } from "../../actions/ActivityIndicatorActions";
import { getFavouriteGames } from "../../actions/GamesActions";

import { console_log, appendUid, filterGames } from '../../utils/helper';

import { FormattedMessage } from 'react-intl';
import { config } from '../../constants/domainConfig';
import { messages_ar } from '../../constants/messages_ar';
import { messages_kk } from '../../constants/messages_kk';
import { messages_fr } from '../../constants/messages_fr';
import { messages_sv } from '../../constants/messages_sv';
import { messages_no } from '../../constants/messages_no';
import { messages_vi } from '../../constants/messages_vi';
import { messages_tr } from '../../constants/messages_tr';
import { messages_it } from '../../constants/messages_it';
import { messages_cy } from '../../constants/messages_cy';
import { messages_de } from '../../constants/messages_de';
import { messages_el } from '../../constants/messages_el';
import { messages_ro} from '../../constants/messages_ro';
import { messages_cz } from '../../constants/messages_cz'
import { messages_pt } from '../../constants/messages_pt';
import { messages } from '../../constants/messages';
import { sendData } from '../../analytics/sendData';
import { isGamiclub } from '../../constants/isGamiclub';
import { isOnlyMobbfun } from '../../constants/isOnlyMobbfun';
import { isGameflares, isGamiway } from '../../constants/productCondition';

let msg;



class Favorites extends Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.openGame = this.openGame.bind(this);
        this.changeDomain = this.changeDomain.bind(this);
        this.state = {
            activeTab: config.subDomain == 'pk' ? '2' : '1'
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        sendData('', '', '', 'viewed', { page: 'favorites' });
    }

    componentWillMount() {
        this.getFavouriteGames();
    }

    getFavouriteGames() {
        let uid = this.props.access.uid;

        axios.get(vars.BASE_URL + '/getFavorites?uid=' + uid)
            .then((response) => {
                if (response.data.success) {
                    this.props.getFavouriteGames(response.data);
                }
            })
            .catch((error) => {
                this.setState({ isValid: false, errorMessage: 'Unable to fetch the data.' });
            });
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }
    changeDomain() {
        switch (config.lang) {
            case 'ar': msg = messages_ar;
                break;
            case 'kk': msg = messages_kk;
                break;
            case 'fr': msg = messages_fr;
                break;
            case 'sv': msg = messages_sv;
                break;
            case 'no': msg = messages_no;
                break;
            case 'vi': msg = messages_vi;
                break;
            case 'tr': msg = messages_tr;
                break;
            case 'it': msg = messages_it;
                break;
            case 'cy': msg = messages_cy;
                break
            case 'de': msg = messages_de;
                break;
            case 'el': msg = messages_el;
                break
            case 'ro': msg = messages_ro;
                break;
            case 'cs': msg = messages_cz;
                break;
            case 'fr': msg = messages_pt;
                break;
            default: msg = messages;
                break;
        }
    }
    openGame(game, e) {
        if (e.target.classList.contains('isFavorite')) {
            let data = {
                uid: this.props.access.uid,
                gameId: game.gameId,
                isFavorite: !game.isFavorite
            };
            sendData(game.gameTitle, game.categoryName, game.gameType, data.isFavorite ? 'favorite-added' : 'favorite-removed');
            axios.post(vars.BASE_URL + '/favorite', data)
                .then((response) => {
                    if (response.status) {
                        this.props.showMessage({
                            message: msg.removeFromFavorites,
                            type: false
                        });
                        this.getFavouriteGames();
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        } else if (e.target.tagName != 'INPUT') {
            this.props.history.push(appendUid('/detail/' + game.gameId, this.props.access.uid));
        }
    }

    render() {
        const html5Games = this.props.games.favoriteGames.filter((game) => game.gameType.toLowerCase() == "html5");
        const androidGames = this.props.games.favoriteGames.filter((game) => game.gameType.toLowerCase() == "android");
        const finalVideos = this.props.games.favoriteGames.filter((game) => game.gameType.toLowerCase() == "video");
        var excludedCategories = ['Motivation','Tour','Fun Gaming','Athletics','E-Learning','Heroes','Squid Games','Astrology','Cuisine','Musique','Apprends le français','Courts métrages','Visites', 'Heróis Verdes', 'Meu Emprego dos Sonhos', 'Political & Activism'];
        var excludedCategorieses2 = ['Motivation','Tour','Fun Gaming','Athletics','E-Learning','Squid Games','Astrology','Cuisine','Musique','Apprends le français','Courts métrages','Visites', 'Heróis Verdes', 'Meu Emprego dos Sonhos']; 
        let videos = finalVideos;
        if(config.subDomain === 'my' && window.location.hostname.includes('gamiclub')) {
            videos = finalVideos.filter((item) => {
                if(excludedCategories.indexOf(item.categoryName) === -1){
                    return item;
                }
            });
        }
        if(config.subDomain === 'es2' && window.location.hostname.includes('beemobi')) {
            videos = finalVideos.filter((item) => {
                if(excludedCategorieses2.indexOf(item.categoryName) === -1){
                    return item;
                }
            });
        }    
        this.changeDomain();
        return (
            <section className="favorites">
                <Row>
                    <Col xs="12">
                    <Nav pills className="nav-justified favorites-tabs">
                {config.subDomain !== 'pk' && (
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '1' })}
                            onClick={() => { this.toggle('1'); }}
                        >
                            {isGamiclub ? <FormattedMessage id="html5" defaultMessage="HTML5" /> : <FormattedMessage id="html5games" defaultMessage="HTML5 Games" />}
                        </NavLink>
                    </NavItem>
                )}
                {config.subDomain === 'pk' || config.subDomain === 'rsma' || config.subDomain === 'maae' || (config.subDomain === 'za' && isIos) || (config.subDomain === 'my' && window.location.hostname.includes('gamiclub.online')) || (config.subDomain === 'ae' && window.location.hostname.includes('game-lords.com')) ? null : (
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '2' })}
                            onClick={() => { this.toggle('2'); }}
                        >
                            {isGamiclub ? <FormattedMessage id="android" defaultMessage="ANDROID" /> : <FormattedMessage id="androidGames" defaultMessage="ANDROID Games" />}
                        </NavLink>
                    </NavItem>
                )}
                {((isGamiclub && config.subDomain !== 'rsma' && !(isOnlyMobbfun && config.subDomain === 'id')  && !(window.location.hostname.includes('game-lords.com') && config.subDomain === 'ae')) || config.subDomain === 'kw' || config.subDomain === 'pt') && (
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '3' })}
                            onClick={() => { this.toggle('3'); }}
                        >
                            <FormattedMessage id="videos" defaultMessage="VIDEOS" />
                        </NavLink>
                    </NavItem>
                )}
            </Nav>
                        <TabContent activeTab={this.state.activeTab}>
                            <TabPane tabId="1">
                                <Row className="game-list-row">
                                    {(html5Games.length > 0) ?
                                        html5Games.map((game) => {
                                            return (
                                                <Col xl="2" md="3" sm="4" xs="6" key={game.gameId}>
                                                    <Card className={isGamiclub ? "game-card-gamiclub" : isGameflares ? "game-card gameflares-game-card": isGamiway ? "game-card gamiway-card":"game-card"} onClick={this.openGame.bind(this, game)}>
                                                        <div className="game-card-inner">
                                                            <div className="game-thumb-wrap" >
                                                                <CardImg className="game-thumb" top width="100%" src={game.gameImage.includes('https://cdn.game-lords.com/games/http') ? game.gameImage.split('https://cdn.game-lords.com/games/')[1] : game.gameImage} alt={game.gameTitle} />
                                                            </div>
                                                            <div className="game-card-details">
                                                                {config.subDomain != 'es' && <CardTitle className="game-title text-shadow">
                                                                    <FormattedMessage id={`${game.gameTitle.toUpperCase()}`}
                                                                        defaultMessage={game.gameTitle}/></CardTitle>}
                                                                <div className="custom-rating isFavorite">
                                                                    <input id={'fav' + game.gameId} ref={'star' + game.gameId} className="isFavorite" type="checkbox" checked={game.isFavorite} />
                                                                    <label htmlFor={'fav' + game.gameId} className="isFavorite">
                                                                        <i style = {isGamiclub ? {color: 'green'} : isGameflares ? {color: '#FF394B'}: isGamiway ? {color:'#b347a0'}: null} className="fa fa-star custom-star isFavorite"></i>
                                                                    </label>
                                                                </div>
                                                                {/*<StarRatingComponent className="abc favorite-star isFavorite" name={'fav'+game.gameId} starCount={1} value={(game.isFavorite) ? 1 : 0} editing={true} renderStarIcon={() => <i className="fa fa-star custom-star fa-gradient isFavorite"></i>} />*/}
                                                                <div className="game-card-left">
                                                                    <StarRatingComponent name="rate1" starCount={5} value={game.userRating} editing={false} renderStarIcon={() => <i style = {isGamiclub ? {color: 'green'} : isGameflares ? {color: '#FF394B'} : isGamiway ? {color:'#b347a0'}: null} className="fa fa-star custom-star"></i>} />
                                                                </div>
                                                                {config.subDomain != 'es' && <div className="game-card-right text-uppercase text-shadow text-right">
                                                                    {(game.gameType.toLowerCase() === "html5") ? <i className="fa fa-html5" aria-hidden="true"></i> : <i className="fa fa-android" aria-hidden="true"></i>}</div>}
                                                                
                                                            </div>
                                                        </div>
                                                    </Card>
                                                </Col>
                                            )
                                        }) :
                                        <Col xs="12">
                                            <div className="favorites-tabs-inner text-center">
                                            {isGamiclub || isGameflares ? <i className={`fa fa-html5 ${isGameflares ? 'fa-gradient-gameflares' :'fa-gradient-gamiclub'}`}></i>
                                                : <i className='fa fa-html5 fa-gradient'></i>}
                                                <p className="favorites-text">
                                                    <FormattedMessage id="noFavGames"
                                                        defaultMessage="No Favorite Games Yet"
                                                    />
                                                </p>
                                                <p className="favorites-sub-text">
                                                    <FormattedMessage id="addFavGames"
                                                        defaultMessage="Add your favorite games to access and play easily without any hassels"
                                                    />
                                                </p>
                                                <a className={isGamiclub ? "btn discover-btn gradient-gamiclub" : isGameflares ? "btn discover-btn gradient-gameflares" : "btn discover-btn gradient"} href={appendUid("/#/home/html", this.props.access.uid)}>
                                                    <FormattedMessage id="discover"
                                                        defaultMessage="Discover"
                                                    />
                                                </a>
                                            </div>
                                        </Col>
                                    }
                                </Row>
                            </TabPane>
                            <TabPane tabId="2">
                                <Row className="game-list-row">
                                    {(androidGames.length > 0) ?
                                        androidGames.map((game) => {
                                            return (
                                                filterGames(game) ?
                                                    <Col xl="2" md="3" sm="4" xs="6" className="fav-android-tab" key={game.gameId}>
                                                        <Card className={isGamiclub ? "game-card-gamiclub" : isGameflares ? "game-card gameflares-game-card" : isGamiway ? "game-card gamiway-card" : "game-card"} onClick={this.openGame.bind(this, game)}>
                                                            <div className="game-card-inner">
                                                                <div className="game-thumb-wrap" >
                                                                    <CardImg className="game-thumb" top width="100%" src={game.gameImage.includes('https://cdn.game-lords.com/games/http') ? game.gameImage.split('https://cdn.game-lords.com/games/')[1] : game.gameImage} alt={game.gameTitle} />
                                                                </div>
                                                                <div className="game-card-details">
                                                                    {config.subDomain != 'es' && <CardTitle className="game-title text-shadow">
                                                                        <FormattedMessage id={`${game.gameTitle.toUpperCase()}`}
                                                                            defaultMessage={game.gameTitle}/></CardTitle>}
                                                                    <div className="custom-rating isFavorite">
                                                                        <input id={'fav' + game.gameId} ref={'star' + game.gameId} className="isFavorite" type="checkbox" checked={game.isFavorite} />
                                                                        <label htmlFor={'fav' + game.gameId} className="isFavorite">
                                                                            <i style = {isGamiclub ? {color: 'green'} : isGameflares ? {color: '#FF394B'} : isGamiway ? {color:'#b347a0'}: null} className="fa fa-star custom-star isFavorite"></i>
                                                                        </label>
                                                                    </div>
                                                                    {/*<StarRatingComponent className="abc favorite-star isFavorite" name="rate1" starCount={1} value={(game.isFavorite) ? 1 : 0} editing={true} renderStarIcon={() => <i className="fa fa-star custom-star fa-gradient isFavorite"></i>} />*/}
                                                                    <div className="game-card-left">
                                                                        <StarRatingComponent name="rate2" starCount={5} value={game.userRating} editing={false} renderStarIcon={() => <i style = {isGamiclub ? {color: 'green'} : isGameflares ? {color: '#FF394B'}: isGamiway ? {color:'#b347a0'} : null} className="fa fa-star custom-star"></i>} />
                                                                    </div>
                                                                    <div className="game-card-right text-uppercase text-shadow text-right">
                                                                        {(game.gameType.toLowerCase() == "html5") ? <i className="fa fa-html5" aria-hidden="true"></i> : <i className="fa fa-android" aria-hidden="true"></i>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Card>
                                                    </Col> : null
                                            )
                                        }) :
                                        <Col xs="12">
                                            <div className="favorites-tabs-inner text-center">
                                                {isGamiclub || isGameflares ? <i className={`fa fa-android ${isGameflares ? 'fa-gradient-gameflares':'fa-gradient-gamiclub'}`}></i>
                                                : <i className='fa fa-android fa-gradient'></i>}
                                                <p className="favorites-text">
                                                    <FormattedMessage id="noFavGames"
                                                        defaultMessage="No Favorite Games Yet"
                                                    />
                                                </p>
                                                <p className="favorites-sub-text">
                                                    <FormattedMessage id="addFavGames"
                                                        defaultMessage="Add your favorite games to access and play easily without any hassels"
                                                    />
                                                </p>
                                                <a className={isGamiclub ? "btn discover-btn gradient-gamiclub" : isGameflares ? "btn discover-btn gradient-gameflares": "btn discover-btn gradient"} href={appendUid("#/home/android", this.props.access.uid)}>
                                                    <FormattedMessage id="discover"
                                                        defaultMessage="Discover"
                                                    />
                                                </a>
                                            </div>
                                        </Col>
                                    }
                                </Row>
                            </TabPane>
                            {isGamiclub ? <TabPane tabId="3">
                                <Row className="game-list-row">
                                    {(videos.length > 0) ?
                                        videos.map((game) => {
                                            return (
                                                <Col xl="2" md="3" sm="4" xs="6" key={game.gameId}>
                                                    <Card className={isGamiclub ? "game-card-gamiclub" : "game-card"} onClick={this.openGame.bind(this, game)}>
                                                        <div className="game-card-inner">
                                                            <div className="game-thumb-wrap" >
                                                                <CardImg className="game-thumb" top width="100%" src={game.gameImage.includes('https://cdn.game-lords.com/games/http') ? game.gameImage.split('https://cdn.game-lords.com/games/')[1] : game.gameImage} alt={game.gameTitle} />
                                                            </div>
                                                            <div className="game-card-details">
                                                                {config.subDomain != 'es' && <CardTitle className="game-title text-shadow">
                                                                    <FormattedMessage id={`${game.gameTitle.toUpperCase()}`}
                                                                    defaultMessage={game.gameTitle}/></CardTitle>}
                                                                <div className="custom-rating isFavorite">
                                                                    <input id={'fav' + game.gameId} ref={'star' + game.gameId} className="isFavorite" type="checkbox" checked={game.isFavorite} />
                                                                    <label htmlFor={'fav' + game.gameId} className="isFavorite">
                                                                        <i style = {isGamiclub ? {color: 'green'} : null} className="fa fa-star custom-star isFavorite"></i>
                                                                    </label>
                                                                </div>
                                                                {/*<StarRatingComponent className="abc favorite-star isFavorite" name={'fav'+game.gameId} starCount={1} value={(game.isFavorite) ? 1 : 0} editing={true} renderStarIcon={() => <i className="fa fa-star custom-star fa-gradient isFavorite"></i>} />*/}
                                                                <div className="game-card-left">
                                                                    <StarRatingComponent name="rate1" starCount={5} value={game.userRating} editing={false} renderStarIcon={() => <i style = {isGamiclub ? {color: 'green'} : null} className="fa fa-star custom-star"></i>} />
                                                                </div>
                                                                <div className="game-card-right text-uppercase text-shadow text-right">
                                                                    {(game.gameType.toLowerCase() == "html5") ? <i className="fa fa-html5" aria-hidden="true"></i> : (game.gameType.toLowerCase() == 'video') ? <i className="fa fa-video-camera" aria-hidden="true"></i> : <i className="fa fa-video-camera" aria-hidden="true"></i>}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Card>
                                                </Col>
                                            )
                                        }) :
                                        <Col xs="12">
                                            <div className="favorites-tabs-inner text-center">
                                                <i className='fa fa-video-camera fa-gradient-gamiclub'></i>
                                                <p className="favorites-text">
                                                    <FormattedMessage id="noFavVideos"
                                                        defaultMessage="No Favorite Videos Yet"
                                                    />
                                                </p>
                                                <p className="favorites-sub-text">
                                                    <FormattedMessage id="addFavVideos"
                                                        defaultMessage="Add your favorite videos to access and play easily without any hassels"
                                                    />
                                                </p>
                                                <a className="btn discover-btn gradient-gamiclub" href={appendUid("/#/home/video", this.props.access.uid)}>
                                                    <FormattedMessage id="discover"
                                                        defaultMessage="Discover"
                                                    />
                                                </a>
                                            </div>
                                        </Col>
                                    }
                                </Row>
                            </TabPane> : null}
                        </TabContent>
                    </Col>
                </Row>
            </section>
        )

    }

}

const mapStateToProps = (state) => {
    return {
        games: state.GamesReducer,
        access: state.WelcomeReducer,
        flashmessage: state.FlashMessageReducer,

    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        show,
        hide,
        getFavouriteGames,
        showMessage
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Favorites);


// WEBPACK FOOTER //
// ./src/components/Favorites/Favorites.js